import * as api from '../api/index.js';      //import the separete file that contains axios functions

//google auth action creator
export const getAuth = (result,token) => (dispatch) => {        
    try {             
      dispatch({ type: 'AUTH', payload: {result,token} });   
    } catch (error) {
      console.log(error);
    }
  }; 

//form auth action creators
export const signIn = (formData,navigate) => async (dispatch) => {
    try {   
      const { data } = await api.signIn(formData);        
      dispatch({ type: 'SIGNIN', payload: data }); 
      navigate('/') ;            //go to home page & show user data whithout refresh  
    } catch (error) {     
        console.log(error);  
        alert("This user doesn't exist or The password is incorrect .. Please check again")      
    }   
  };

export const signUp = (formData,navigate) => async (dispatch) => {         
    try {         
      const { data } = await api.signUp(formData);
      dispatch({ type: 'SIGNUP', payload: data });
      navigate('/') ;          //go to home page & show user data whithout refresh  
    } catch (error) {
      console.log(error);
      alert("This email is already registered or the passwords doesn't match .. Please check again")
    }
  };  

//logOut action creator
export const logOut = () => (dispatch) => {
    try {             
      dispatch({ type: 'LOGOUT' });               
    } catch (error) {
      console.log(error);
    }
 }; 
   